const actionsType = {
    GET_CREDENTIALS: 'getCredentials',
    CHANGE_CREDENTIALS: 'changeCredentials',
    LOGIN: 'login'
}

const mutationsType = {
    SET_USER_NAME: 'setUserName',
    SET_AVATAR: 'setAvatar',
    SET_TOKEN: 'setToken',
    LOGOUT: 'logout',
    TOGGLE_LOGGED: 'toggleLogged'
}

const stateType = {
    TOKEN: 'token',
    USER_NAME: 'userName',
    USER_AVATAR: 'userAvatar',
    LOGGED: 'logged'
}

export {actionsType, mutationsType, stateType };